module.exports = __webpack_public_path__ + "static/media/credit-card.6dbfe35e.svg";